<template>
  <router-view/>
</template>

<script>
export default {
  name: "Quotation"
};
</script>

<style>
</style>
